import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const dateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const getStoredResultsByDate = createServerFn({ method: "GET" })
  .inputValidator((data: { date: string }) => ({ date: dateSchema.parse(data.date) }))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data: rows, error } = await supabaseAdmin
      .from("lottery_results")
      .select("*")
      .eq("draw_date", data.date);
    if (error) throw new Error(error.message);
    return rows ?? [];
  });

export const listStoredResultDates = createServerFn({ method: "GET" })
  .handler(async () => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data, error } = await supabaseAdmin
      .from("lottery_results")
      .select("draw_date")
      .order("draw_date", { ascending: false });
    if (error) throw new Error(error.message);
    const set = new Set<string>((data ?? []).map((r: any) => r.draw_date));
    return Array.from(set);
  });